export const MESSAGES = {
  REQUEST_ERROR: "Failed to fetch GRN list",
  NO_REQUESTS_AVAILABLE: "No GRNs Available",
  UPDATE_SUCCESS: "GRN updated successfully",
  UPDATE_ERROR: "Failed to update GRN",
  DELETE_SUCCESS: "GRN deleted successfully",
  DELETE_ERROR: "Failed to delete GRN",
  CREATE_SUCCESS: "GRN created successfully",
  CREATE_ERROR: "Failed to create GRN",
  PO_SEARCH_ERROR: "Failed to fetch purchase orders",
  DETAIL_LOAD_ERROR: "Failed to fetch GRN details",
  REFRESH_PO_ITEMS_SUCCESS: "PO items refreshed successfully",
  REFRESH_PO_ITEMS_ERROR: "Failed to refresh PO items",
  ITEMS_LOAD_ERROR: "Failed to fetch received items",
  ITEM_ADD_SUCCESS: "Item added successfully",
  ITEM_ADD_ERROR: "Failed to add item",
  ITEM_REMOVE_SUCCESS: "Item removed successfully",
  ITEM_REMOVE_ERROR: "Failed to remove item",
};

export const CONFIRM_DELETE_GRN = "Are you sure you want to delete this GRN?";

export const DRAFT = "DRAFT";
export const PENDING_L1_APPROVAL = "PENDING_L1_APPROVAL";

export const GRN_LIST_COLUMNS = [
  "grn_id",
  "zoho_po_number",
  "vendor_name",
  "site_name",
  "po_date",
  "created",
  "created_by",
  "approval_status",
  "actions",
];

export const GRN_LIST_LABELS = {
  grn_id: "GRN ID",
  zoho_po_number: "PO Number",
  vendor_name: "Vendor Name",
  site_name: "Site",
  po_date: "PO Date",
  created: "Created On",
  created_by: "Created By",
  approval_status: "Status",
  actions: "Actions",
};

export const APPROVAL_STATUS_STYLES = {
  DRAFT: "bg-gray-100 text-gray-700",
  PENDING_L1_APPROVAL: "bg-yellow-100 text-yellow-700",
  PENDING_L2_APPROVAL: "bg-yellow-100 text-yellow-700",
  APPROVED: "bg-green-100 text-green-700",
  REJECTED: "bg-red-100 text-red-700",
};

export const GRN_INFO_LABELS = {
  grn_id: "GRN ID",
  zoho_po_number: "PO Number",
  vendor_name: "Vendor Name",
  site_name: "Site",
  po_date: "PO Date",
  created: "Created On",
  created_by: "GRN Created By",
  approval_status: "Status",
};

export const APPROVED = "APPROVED";

export const ACCEPTED = "ACCEPTED";

export const ITEM_STATUS_STYLES = {
  ACCEPTED: "bg-green-100 text-green-700",
  DAMAGED: "bg-red-100 text-red-700",
  MISSING: "bg-gray-200 text-gray-800",
  PARTIALLY_DAMAGED: "bg-yellow-100 text-yellow-700",
};

export const ITEM_STATUS_LABELS = {
  ACCEPTED: "Good Condition",
  DAMAGED: "Damaged",
  MISSING: "Missing",
  PARTIALLY_DAMAGED: "Partially Damaged",
};

export const CONFIRM_DELETE_GRN_ITEM =
  "Are you sure you want to remove this item from the GRN?";
